
import { Component, Prop, Vue, Emit } from 'nuxt-property-decorator'

@Component
export default class ReviewsPagination extends Vue {
  @Prop({ required: true }) currentPage!: number
  @Prop({ required: true }) pagesNumber!: number

  // TODO: Perhaps it should be moved to utils
  get pagination () {
    const current = this.currentPage
    const last = this.pagesNumber
    const delta = 1
    const left = current - delta
    const right = current + delta + 1
    const range = []
    const rangeWithDots = []
    let l

    for (let i = 1; i <= last; i++) {
      if ((i === 1 || i === last) || (i >= left && i < right)) {
        range.push(i)
      }
    }

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1)
        } else if (i - l !== 1) {
          rangeWithDots.push('...')
        }
      }
      rangeWithDots.push(i)
      l = i
    }

    return rangeWithDots
  }

  get prevPage () {
    return this.currentPage - 1
  }

  get nextPage () {
    return this.currentPage + 1
  }

  @Emit()
  updateCurrentPage (page: number) {
    return page
  }
}
